import * as React from 'react';
import styles from './mfa-secondary.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

MfaSecondary.defaultProps = {
    as: 'div',
};

export function MfaSecondary({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['mfa-secondary']}>{children}</Tag>;
}
